import { useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import { Instagram, Mail, MapPin, Phone, Facebook } from "lucide-react";

export default function Contact() {
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/contact", form);
      toast.success("Your note has been received");
      setForm({ name: "", email: "", message: "" });
    } catch {
      toast.error("Could not send. Please try again.");
    } finally { setLoading(false); }
  };

  return (
    <div>
      <section className="px-6 md:px-12 lg:px-24 py-20 grid grid-cols-1 lg:grid-cols-12 gap-14">
        <div className="lg:col-span-5">
          <div className="text-[11px] tracking-overline uppercase text-stone-500 mb-3">Write to Us</div>
          <h1 className="font-serif-h font-light text-5xl md:text-6xl text-stone-900 leading-tight">We'd love to hear from you.</h1>
          <p className="mt-6 text-stone-600 font-light leading-relaxed">
            Styling queries, custom orders, trunk shows — drop us a note and our atelier team will reply within 24 hours.
          </p>

          <div className="mt-12 space-y-6">
            <div className="flex gap-4" data-testid="contact-address"><MapPin strokeWidth={1.2} className="text-[#D4AF37] mt-1 flex-shrink-0"/><div><div className="text-[11px] tracking-overline uppercase text-stone-500">Boutique</div><div className="mt-1 leading-relaxed">Riddhi — Drape the Elegance<br/>#83/A, 11th Cross, Next to Srinivasa Temple,<br/>Mahalaxmi Layout, Bengaluru — 560086</div></div></div>
            <div className="flex gap-4" data-testid="contact-email-info"><Mail strokeWidth={1.2} className="text-[#D4AF37] mt-1 flex-shrink-0"/><div><div className="text-[11px] tracking-overline uppercase text-stone-500">Email</div><a className="mt-1 block hover:text-[#D4AF37]" href="mailto:admin@riddhidrape.in">admin@riddhidrape.in</a></div></div>
            <div className="flex gap-4" data-testid="contact-phone"><Phone strokeWidth={1.2} className="text-[#D4AF37] mt-1 flex-shrink-0"/><div><div className="text-[11px] tracking-overline uppercase text-stone-500">Phone</div><a className="mt-1 block hover:text-[#D4AF37]" href="tel:+918660515091">+91 86605 15091</a><a className="block hover:text-[#D4AF37]" href="tel:+919448791054">+91 94487 91054</a></div></div>
          </div>

          <div className="flex gap-4 mt-10">
            <a className="w-11 h-11 border border-warm flex items-center justify-center hover:border-[#D4AF37] hover:text-[#D4AF37] transition" href="https://www.instagram.com/riddhi_drape_the_elegance/" target="_blank" rel="noreferrer" aria-label="Instagram"><Instagram size={18} strokeWidth={1.2}/></a>
            <a className="w-11 h-11 border border-warm flex items-center justify-center hover:border-[#D4AF37] hover:text-[#D4AF37] transition" href="https://www.facebook.com/profile.php?id=61567529159316" target="_blank" rel="noreferrer" aria-label="Facebook"><Facebook size={18} strokeWidth={1.2}/></a>
          </div>
        </div>

        <div className="lg:col-span-7">
          <form onSubmit={submit} className="border border-warm bg-white p-8 md:p-12 rounded-sm" data-testid="contact-form">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-8">
              <div><label className="text-[11px] tracking-overline uppercase text-stone-500">Name</label>
                <input required className="input-line" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} data-testid="contact-name" /></div>
              <div><label className="text-[11px] tracking-overline uppercase text-stone-500">Email</label>
                <input required type="email" className="input-line" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} data-testid="contact-email" /></div>
              <div className="md:col-span-2"><label className="text-[11px] tracking-overline uppercase text-stone-500">Message</label>
                <textarea required className="input-line min-h-[140px] pt-3" value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })} data-testid="contact-message" /></div>
            </div>
            <button disabled={loading} className="btn-ink mt-10 disabled:opacity-50" data-testid="contact-submit">{loading ? "Sending..." : "Send Message"}</button>
          </form>
        </div>
      </section>
    </div>
  );
}
